import { render } from "./SlideTabs.vue?vue&type=template&id=392ee991&scoped=true"
import script from "./SlideTabs.vue?vue&type=script&lang=js"
export * from "./SlideTabs.vue?vue&type=script&lang=js"

import "./SlideTabs.vue?vue&type=style&index=0&id=392ee991&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392ee991"]])

export default __exports__